import { useTranslation } from 'react-i18next'

import Button from '../../Button'

function TableModalButtonCancel({
  Component = Button.Outlined,
  text = 'Modal.CancelBtnKey',
  ...restProps
}) {
  const { t } = useTranslation()

  return <Component {...restProps} text={t(text)} />
}

export default TableModalButtonCancel
